import styled from 'styled-components'

const Container = styled.div`
  /* margin-left: 80px; */
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.body};
  margin-top: 20px;
  .fixed-width {
    width: 100%;
    /* margin-top: -40px; */
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    margin-left: 0px;
    overflow-x: hidden;
  }
  .button {
    background-color: ${({ theme }) => theme.colors.TargetColor};
    a {
      color: white;
    }
  }
  .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    margin-left: 5px;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 88vw;
      margin-top: 20px;
    }
    h2 {
      font-family: ${({ theme }) => theme.fontFamily.visuelt};
      font-style: Medium;
      font-size: ${({ theme }) => theme.fontSize.xx3};
      letter-spacing: 0.75%;
      color: ${({ theme }) => theme.colors.successGreen};

      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        margin-right: 15px;
        font-size: ${({ theme }) => theme.fontSize.x6};
      }
    }

    @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
      margin-top: 25px;
    }
  }
`
const LinkWrapper = styled.div`
  display: flex;
  height: 120px;
  width: 100%;
  margin-top: 20px;

  margin-bottom: 30px;

  .swiper-container {
    margin-left: -12px;
  }
  .owl-theme {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    height: auto;
    margin-left: -10px;
  }

  .link {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    margin-top: 20px;
    margin-top: 20px;
  }
  .link-box {
    margin-right: 50px;
    width: 200px;
  }

  .link-name {
    font-size: 18px;
    line-height: 22px;
    padding-left: 10px;
  }
  .target {
    color: ${({ theme }) => theme.colors.successGreen};
  }
`

const CardBtnWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
    width: 100%;
    margin-left: 0px;
  }

  /* New TargetCard style */

  .card_one {
    background-color: ${({ theme }) => theme.colors.TargetColor};
    color: ${({ theme }) => theme.colors.white};
    height: 120px;
    width: 90%;

    .flex_wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-around;
    }

    .balance {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.xxl};
      letter-spacing: 1px;
      margin: 0;
      @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
        font-size: ${({ theme }) => theme.fontSize.x1};
      }
    }

    .title {
      font-weight: 400;
      font-size: ${({ theme }) => theme.fontSize.x2};
      font-family: ${({ theme }) => theme.fontFamily.inter};
      line-height: 26px;
      letter-spacing: 0.75px;
      margin: 0;
    }

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 100%;
    }
  }
  .card_two {
    background-color: ${({ theme }) => theme.colors.stillSellingBg};
    width: 60%;
    height: 125px;
    color: ${({ theme }) => theme.colors.navyBlue};

    .flex_wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      flex-direction: column-reverse;
    }

    .balance {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.x2};
      letter-spacing: 1px;
      margin: 0;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: ${({ theme }) => theme.fontSize.x1};
      }
    }

    .title {
      font-weight: 400;
      font-size: ${({ theme }) => theme.fontSize.x4};
      font-family: ${({ theme }) => theme.fontFamily.inter};
      line-height: 26px;
      letter-spacing: 0.75px;
      margin: 0;
    }

    .icon_wrapper {
      align-self: flex-end;
      margin-top: 1rem;
    }

    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
  }

  .general-owl-theme {
  }
  .owl-dots {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      display: none;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
    }
  }

  .owl-carousel button.owl-dot {
    background: #6e7191;
    color: white;
    border: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .owl-carousel {
    z-index: 0;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      z-index: 0;
    }
  }
  .owl-carousel button.owl-dot.active {
    background: ${({ theme }) => theme.colors.TargetColor};
    border-radius: 10px;
    margin: 0 5px;
    width: 22px;
    height: 6px;
  }

  /* New TargetCard style */

  .btn-container {
    display: flex;
    width: 320px;
    justify-content: space-between;
    margin-top: 10px;
    margin-left: -5px;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      /* padding-right: 2px; */
      margin: 0rem 0;
    }
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
  }
`

const TargetDataWrapper = styled.div`
  width: 100%;
  .target {
    color: ${({ theme }) => theme.colors.dark};
  }

  .target-btn-container {
    margin-left: 5px;
    margin-top: 0px;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: auto;
      display: flex;
      margin-left: 0px;
    }
  }
`
const TransactionContainer = styled.div`
  width: 90%;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }
  .web-transaction {
    display: block;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: 0rem;
    }
  }

  .mobile-transaction {
    display: none;
    margin-top: 0rem;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: block;
    }
  }
`
export {
  Container,
  LinkWrapper,
  CardBtnWrapper,
  TargetDataWrapper,
  TransactionContainer,
}
